import './assets/css/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { vMaska } from "maska/vue";
import './plugins/axios';

import App from './App.vue'
import CKEditor from "@ckeditor/ckeditor5-vue"
import './registerServiceWorker'
import router from './router'
import lazyload from './directives/lazyload'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)
app.use(CKEditor)
app.directive("lazyload", lazyload);
app.directive("maska", vMaska)
app.mount('#app')
